import { all, takeEvery, put, call } from "redux-saga/effects";
import store from "store";
import actions from "./actions";

export function* GET_SETTINGS({ payload }) {
  console.log(payload, "payload");
  yield put({
    type: "settings/SET_STATE",
    payload: {},
  });
}

export function* CHANGE_SETTING({ payload: { setting, value } }) {
  yield store.set(`app.settings.${setting}`, value);
  yield put({
    type: "settings/SET_STATE",
    payload: {
      [setting]: value,
    },
  });
}

export function* SET_USER_TABLE_COLUMNS({ payload }) {
  yield put({
    type: actions.SET_USER_TABLE_COLUMNS,
    payload,
  });
}

export function* SET_WISHLIST({ payload }) {
  yield put({
    type: actions.SET_WISHLIST,
    payload,
  });
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.CHANGE_SETTING, CHANGE_SETTING),
    takeEvery(actions.GET_SETTINGS, GET_SETTINGS),
    takeEvery(actions.SET_USER_TABLE_COLUMNS_REQ, SET_USER_TABLE_COLUMNS),
    takeEvery(actions.SET_WISHLIST_REQ, SET_WISHLIST),
  ]);
}
